module.exports = __webpack_public_path__ + "img/tuxiang81.1117c165.png";